import { render, staticRenderFns } from "./welcome-sidebar.vue?vue&type=template&id=e47d15fc&scoped=true&"
import script from "./welcome-sidebar.vue?vue&type=script&lang=js&"
export * from "./welcome-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./welcome-sidebar.vue?vue&type=style&index=0&id=e47d15fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47d15fc",
  null
  
)

export default component.exports